module.exports = __webpack_public_path__ + "static/aboutClients-3c516c0ed898484037a7eb8d192bf9d1.png";